import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import mergeOperations from '@magento/peregrine/lib/util/shallowMerge';
import DEFAULT_OPERATIONS from './availableOutlet.gql';
export var useAvailableOutlet = function useAvailableOutlet() {
  var _data$products3, _data$products4, _data$products4$items, _data$products5, _data$products5$items, _data$products5$items2;

  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var outletSku = props.outletSku;
  var operations = mergeOperations(DEFAULT_OPERATIONS, props.operations);
  var getRelatedOutletItems = operations.getRelatedOutletItems;

  var _useQuery = useQuery(getRelatedOutletItems, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      filters: {
        hf_base_item_nbr: {
          match: outletSku === null || outletSku === void 0 ? void 0 : outletSku.replace('OUT-', '')
        }
      }
    }
  }),
      data = _useQuery.data;

  var isAvailableInOutletLink = useMemo(function () {
    var _data$products, _data$products$items, _data$products2, _data$products2$items;

    var findGroupedProduct = data === null || data === void 0 ? void 0 : (_data$products = data.products) === null || _data$products === void 0 ? void 0 : (_data$products$items = _data$products.items) === null || _data$products$items === void 0 ? void 0 : _data$products$items.find(function (item) {
      return (item === null || item === void 0 ? void 0 : item.__typename) === 'GroupedProduct';
    });
    var checkForSimpleProduct = data === null || data === void 0 ? void 0 : (_data$products2 = data.products) === null || _data$products2 === void 0 ? void 0 : (_data$products2$items = _data$products2.items) === null || _data$products2$items === void 0 ? void 0 : _data$products2$items.find(function (item) {
      return (item === null || item === void 0 ? void 0 : item.__typename) === 'SimpleProduct';
    });
    if (findGroupedProduct && checkForSimpleProduct) return findGroupedProduct === null || findGroupedProduct === void 0 ? void 0 : findGroupedProduct.url_key;
    return false;
  }, [data === null || data === void 0 ? void 0 : (_data$products3 = data.products) === null || _data$products3 === void 0 ? void 0 : _data$products3.items]);
  var outletItems = data === null || data === void 0 ? void 0 : (_data$products4 = data.products) === null || _data$products4 === void 0 ? void 0 : (_data$products4$items = _data$products4.items) === null || _data$products4$items === void 0 ? void 0 : _data$products4$items.filter(function (item) {
    var _item$sku;

    return item.sku !== outletSku && (item === null || item === void 0 ? void 0 : (_item$sku = item.sku) === null || _item$sku === void 0 ? void 0 : _item$sku.startsWith('OUT-')) && item.__typename == 'SimpleProduct';
  }); // const baseItemSku = outletSku.replace('OUT-', '', outletSku).substring(0, outletSku.replace('OUT-', '', outletSku).indexOf('-'));

  var configurableOptions = data === null || data === void 0 ? void 0 : (_data$products5 = data.products) === null || _data$products5 === void 0 ? void 0 : (_data$products5$items = _data$products5.items) === null || _data$products5$items === void 0 ? void 0 : (_data$products5$items2 = _data$products5$items.find(function (item) {
    return item.__typename == 'ConfigurableProduct';
  })) === null || _data$products5$items2 === void 0 ? void 0 : _data$products5$items2.configurable_options;
  return {
    outletItems: outletItems,
    configurableOptions: configurableOptions,
    isAvailableInOutletLink: isAvailableInOutletLink
  };
};